import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { History, CalendarClock, Bot, User } from 'lucide-react';
import api from '../../utils/axios';
import { SyncHistorialDialog, EstadoBadge, fmtFechaHora, fmtDuracion, origenLabel } from './SyncHistorialDialog';

const TZ = 'America/Argentina/Buenos_Aires';
const diaART = (d) => d.toLocaleDateString('en-CA', { timeZone: TZ });

const proximaLabel = (iso) => {
  if (!iso) return 'desactivada';
  const d = new Date(iso);
  const manana = new Date(Date.now() + 86400000);
  const hora = d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', timeZone: TZ });
  if (diaART(d) === diaART(new Date())) return `hoy ${hora} (ART)`;
  if (diaART(d) === diaART(manana)) return `mañana ${hora} (ART)`;
  return `${d.toLocaleString('es-AR', { timeZone: TZ })} (ART)`;
};

export const SyncWayaStatus = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    api.get('/motor/sync-waya/corridas', { params: { limit: 30 } }).then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);
  useEffect(() => {
    if (!data?.en_curso) return undefined;
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [data?.en_curso, load]);

  if (!data) return null;
  const ult = data.items?.find((i) => i.status !== 'omitida');
  const omitida = data.items?.[0]?.status === 'omitida' ? data.items[0] : null;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-xs text-slate-600 dark:bg-slate-900 dark:border-slate-800" data-testid="sync-waya-status">
      {ult ? (
        <span className="flex flex-wrap items-center gap-2" data-testid="sync-ultima">
          <span className="font-semibold text-slate-700 dark:text-slate-200">Última actualización:</span>
          <span className="tabular-nums">{fmtFechaHora(ult.started_at)}</span>
          <EstadoBadge status={ult.status} testid="sync-ultima-estado" />
          <span className="flex items-center gap-1 text-slate-500">{ult.origen === 'manual' ? <User size={12} /> : <Bot size={12} />} {origenLabel(ult)}</span>
          {ult.duracion_seg != null && <span className="text-slate-400">· {fmtDuracion(ult.duracion_seg)}</span>}
        </span>
      ) : <span>Sin corridas registradas todavía.</span>}
      {omitida && (
        <span className="text-slate-400" data-testid="sync-omitida">
          · {fmtFechaHora(omitida.started_at)}: {omitida.resumen}
        </span>
      )}
      <span className="flex items-center gap-1.5" data-testid="sync-proxima">
        <CalendarClock size={13} className="text-teal-600" /> Próxima automática: <b className="text-slate-700 dark:text-slate-200">{proximaLabel(data.proxima)}</b>
      </span>
      <Button size="sm" variant="ghost" className="ml-auto h-7 text-teal-700 hover:bg-teal-50" onClick={() => { load(); setOpen(true); }} data-testid="sync-historial-btn">
        <History size={14} className="mr-1.5" /> Historial
      </Button>
      <SyncHistorialDialog open={open} onOpenChange={setOpen} data={data} />
    </div>
  );
};

export default SyncWayaStatus;
